import React, {useState} from "react";

//import { Autoplay, A11y} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import SwiperCore, {EffectCoverflow, Pagination,Autoplay} from 'swiper';
import './view6.scss'

import woman from '../../../img/landing/woman.svg'
import man from '../../../img/landing/man.svg'
import Quote from '../../../img/landing/quote.svg'

SwiperCore.use([Pagination,Autoplay]);


const View6 = (props) => {
    const pageType = props.pageType ?? null;
    const [swiper, setSwiper] = useState(null)
    const [activeIndex, setActiveIndex] = useState(0);

    const handleSlideClick = (index) => {
        swiper.slideTo(index);
        setActiveIndex(index);
    };

    const updateActiveIndex = () => {
        if (swiper) {
            setActiveIndex(swiper.activeIndex);
        }
    };

    const items = [
        {
            'type': 'history',
            'image': man,
            'name': 'علیرضا عمادی',
            'content': 'من توی اردیبهشت ماه با وزن 109 کیلو رژیم رو شروع کردم و الان بعد از سه ماه به وزن 98 کیلو رسیدم. جالب اینجاس که حین رژیم احساس گرسنگی بهم دست نمیداد و خیلی راحت تونستم وزن کم کنم.\n' +
                'مرسی از برنامه خوب چنگال...'
        },
        {
            'type': 'history',
            'image': woman,
            'name': 'مینا طالب زاده',
            'content': 'بعد از این که باردار شدم حدود 18 کیلوگرم افزایش وزن پیدا کردم که باعث شد به کل اعتماد بنفسم رو از دست بدم. بعد از جستجو توی اینترنت سایت چنگال رو دیدم و رژیم لاغریشو خریدم و الان بعد از شش ماه حدود 15 کیلوگرم وزنم کم شده و دارم به وزن قبلیم برمیگردم.'
        },
        {
            'type': 'history',
            'image': man,
            'name': 'محمدحسین شفیعی',
            'content': 'به علت چاقی زیاد توی 21 سالگی مبتلا به کمردرد و زانودرد شدم و از همون دوره خیلی چاق تر شده بودم. رژیم کاهش وزن رو با چنگال شروع کردم و در عرض سه ماه هفت کیلو وزنمو کم کردم.'
        },
        {
            'type': 'history',
            'image': woman,
            'name': 'سارا یزدانی',
            'content': 'من بعد از این که پدرم رو از دست دادم دچار افسردگی شدم و طی یک سالو نیم 14 کیلو اضافه وزن پیدا کردم. به پیشنهاد دخترخالم رژیم چنگال رو شروع کردم و با رژیم غذاییش تونستم در عرض شش ماه 12 کیلو کم کنم. اصلا امروز فردا نکنید و شروع کنین چون واقعا هیچی بدتر از چاقی اعتماد بنفس آدمو نمیگیره.'
        },
        {
            'type': 'history',
            'image': woman,
            'name': 'فاطمه سلطانی',
            'content': 'به خاطر ریزه خواری وزنم واقعا زیاد شده بود جوری که لباس سایزم سخت گیر میومد. اما دوستم که قبلا رژیم لاغری گرفته بود چنگال رو بهم معرفی کرد و منم شروع کردم به رعایت کردن. اوایل سخت بود ولی یک ماه که گذشت دیگه به سبک جدید غذا خوردن سالم عادت کردم و به همین شکل تونستم شش ماهه 15 کیلو وزن کم کنم'
        },
        {
            'type': 'history',
            'image': man,
            'name': 'محسن سروری',
            'content': 'من کشتی گیر هستم و نیاز دارم خیلی وزنم را بالا پایین کنم. توی خانواده ژنتیک لاغری داریم و منم به راحتی وزنم میارم پایین ولی برای وزن گرفتن خیلی اذیت میشدم. قبل یکی از مسابقات توی اینترنت که جستجو میکردم سایت چنگال را دیدم و رژیم افزایش وزنش را استفاده کردم و با این که ورزش سخت میکردم ولی تقریبا توی ماه اول 3 کیلو اضافه کردم و الان توی ماه دوم رژیمم هستم.'
        },
        {
            'type': 'history',
            'image': woman,
            'name': 'مبینا افخمی',
            'content': 'سلام من شش ماه هست که ازدواج کردم و خیلی دلم میخواست که وزنم رو مثل قبل نگه دارم تا اینکه یکی از همکارام که رژیم لاغری گرفته بود اپلیکیشن چنگال رو برام فرستاد. من با پشتیبانیشون تماس گرفتم و بهشون گفتم میخام وزنم ثابت بمونه و راهنماییم کردن و الان چهار ماهه  دارم رژیم میگیرم و نهایتا یک کیلو کاهش یا افزایش وزن داشتم بین این چهارماه.'
        },
    ]
    return (<>

        <div className='view6'>
            <div className={`items-center mb-10 pb-12`}>
                <div className={`title text-medium text-bolder mb-4`}>داستان با اراده های چنگال</div>
                <div className={'bottom-border-orange mb-4'}/>


                <div className='slide-container'>
                    <Swiper
                        slidesPerView={1}
                        breakpoints={{
                            768: {
                                slidesPerView: 3,
                            },
                        }}
                        onSwiper={setSwiper}
                        onSlideChange={updateActiveIndex}
                        spaceBetween={30}
                        pagination={{
                            clickable: true,
                            type: 'bullets',
                            dynamicBullets: true
                        }}
                        loop={true}
                        effect={'coverflow'}
                        grabCursor={true}
                        modules={[EffectCoverflow, Pagination]}
                        centeredSlides={true}
                        coverflowEffect={{
                            rotate: 0,
                            stretch: -120,
                            depth: 200,
                            modifier: 1,
                            slideShadows: false,
                        }}

                        autoplay={{ delay: 5000 }}
                    >
                        {items.map((item, index) => (
                            <SwiperSlide key={index}
                                         className={`zoom-slide ${activeIndex === index ? 'zoomed' : ''}`}
                                         onClick={() => handleSlideClick(index)}>
                                <div
                                    className='  select-none mb-4 '>
                                    <div className={''}>
                                        <img
                                            src={Quote}
                                            alt={`slide-image-${index + 1}`}
                                            className={`history-quote-active`}
                                        />

                                        <div
                                            className={`pb-8 text-content`}>{item.content}</div>
                                    </div>
                                    <div className={'flex flex-end'}>
                                        <img
                                            src={ item.image}
                                            alt={`slide-image-${index + 1}`}
                                            className={`mb-4 mt-8 history-image`}
                                        />
                                        <div className={'mb-4'}>{item.name}</div>
                                    </div>
                                </div>
                            </SwiperSlide>

                        ))}
                    </Swiper>
                </div>


            </div>
        </div>


    </>)
}
export default View6;
